import React from 'react';
import PropTypes from 'prop-types';
import './csmArticleMeta.css';
import { AddThis } from './../addThis';
import moment from 'moment';
import { Link } from 'react-router';

class CsmArticleMeta extends React.Component {
  render() {
    let creationDate = moment(this.props.creationDate).calendar(null, {
      sameDay: '[Dnes] | HH:mm',
      nextDay: '[Zajtra]',
      nextWeek: 'dddd',
      lastDay: '[Včera] | HH:mm',
      lastWeek: 'DD.MM.YYYY | HH:mm',
      sameElse: 'DD.MM.YYYY | HH:mm',
    });
    // Prve pismeno velke. Zrusil som to, s malym to vyzera lepsie.
    //creationDate = `${creationDate[0].toLocaleUpperCase()}${creationDate.substring(1)}`;
    return (
      <div className="article-meta">
        <div className="row">
          <div className="col-md-6 text-muted">
            {this.props.authorPicture && (
              <img
                style={{
                  width: '50px',
                  borderRadius: '50%',
                  marginRight: '10px',
                }}
                src={`https://data.tvkosice.sk/images/cm/100x100xmedia/${this.props.authorPicture}`}
                alt=""
              />
            )}
            {this.props.authorName ? (
              <React.Fragment>
                <Link to={`/autor/${this.props.authorName}`}>{this.props.authorName}</Link>, {creationDate}
              </React.Fragment>
            ) : (
              creationDate
            )}
          </div>
          {this.props.allowShare && (
            <div className="col-md-6 text-right">
              <AddThis
                shareUrl={this.props.shareUrl}
                shareTitle={this.props.shareTitle}
                sharePicture={this.props.sharePicture}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

CsmArticleMeta.defaultProps = {
  allowShare: true,
};

CsmArticleMeta.propTypes = {
  creationDate: PropTypes.string.isRequired,
  authorName: PropTypes.string,
  authorPicture: PropTypes.string,
  allowShare: PropTypes.bool,
  shareUrl: PropTypes.string,
  shareTitle: PropTypes.string,
  sharePicture: PropTypes.string,
};

export default CsmArticleMeta;



// WEBPACK FOOTER //
// ./src/ui/src/component/csmArticle/csmArticleMeta.js